import React from 'react'
import getMovieLink from '../../functions/getMovieLink'
import { getItemsWithInterscroller } from '../../functions/weischerHelpers'
import Translation from '../../General/Translation'
import MovieListItemContainer from './MovieListItemContainer'
import OverviewInterscroller from '../OverviewInterscroller'
import { compose } from 'redux'
import { connect } from 'react-redux'
import toJS from '../../hoc/toJS'
import { FRONT } from '../../constants/state'
import getData from '../../functions/getData'

const mapStateToProps = (state, ownProps) => ({
    cinemaDataFront: getData(state, FRONT), 
})

const FilterResultsList = ({
    queryStringValues, 
    interscrollerWeischerAds, 
    interscrollerAdvertisements,
    additionalScrollName='', 
    items, 
    itemsData, 
    isSingleMovie, 
    isMobile,
    displaySidebarRight, 
    dayFilters,
    onSidebarRightOpen, 
    displaySidebarRightSecond, 
    onSidebarRightClose,  
    performancePageOpen, 
    activePerformance, 
    onOpenPerformancePage, 
    onClosePerformancePage, 
    translation, 
    moviesRoutesData,
    selectionId,
    activeSelection,
    activeDetailsItem, 
    overviewFilterIgnoreOnPerformances,
    onOpenDetails, 
    onCloseDetails,
    hideCinemaSelector,
    clusterCinemaActive,
    clusterCinemaOption,
    activeCinema,
    currentCinemaType,
    cinemaDataFront
}) => {

    const {
        program_overview_list_style,
    } = cinemaDataFront

    const integer = Math.ceil(items.length/6) >= 4 ? 6 : 3
    const { interscrollerId, interscrollerType, itemsWithInterscroller } = getItemsWithInterscroller(items, interscrollerWeischerAds, interscrollerAdvertisements, integer)

    return (
        <div className="grid-site-wrapper">
            <div className="overview-grid">
                {0 === itemsWithInterscroller.length ? (
                    <h3 className="no-movie title-xlarge-theatre">
                        <Translation id="ThereCurrentlyNoFilmsTypes" trans={translation} />
                    </h3>
                ):(
                    <div className={"list-grid " + program_overview_list_style}>
                        {itemsWithInterscroller.map((itemId, index) => {
                            if(interscrollerType && interscrollerId === itemId) {
                                return <OverviewInterscroller
                                    key={index}
                                    itemClass="movie-item"
                                    interscrollerType={interscrollerType}
                                    interscrollerWeischerAds={interscrollerWeischerAds}
                                    interscrollerAdvertisements={interscrollerAdvertisements}
                                    styles={{}}
                                />
                            } else {
                                return (
                                    <MovieListItemContainer
                                        overviewFilterIgnoreOnPerformances={overviewFilterIgnoreOnPerformances}
                                        key={index}
                                        dayFilters={dayFilters}
                                        additionalScrollName={additionalScrollName}
                                        clusterCinemaActive={clusterCinemaActive}
                                        clusterCinemaOption={clusterCinemaOption}
                                        activeCinema={activeCinema}
                                        index={index}
                                        queryStringValues={queryStringValues}
                                        isMobile={isMobile}
                                        id={itemId}
                                        itemsData={itemsData}
                                        currentCinemaType={currentCinemaType}
                                        hideCinemaSelector={hideCinemaSelector}
                                        itemData={itemsData[itemId]}
                                        isSingleMovie={isSingleMovie}
                                        displaySidebarRight={displaySidebarRight}
                                        displaySidebarRightSecond={displaySidebarRightSecond}
                                        onSidebarRightOpen={onSidebarRightOpen}
                                        onSidebarRightClose={onSidebarRightClose}
                                        performancePageOpen={performancePageOpen}
                                        activePerformance={activePerformance}
                                        onOpenPerformancePage={onOpenPerformancePage}
                                        onClosePerformancePage={onClosePerformancePage}
                                        translation={translation}
                                        itemLink={getMovieLink(itemId, moviesRoutesData, translation)}
                                        selectionId={selectionId}
                                        activeSelection={activeSelection}
                                        activeDetailsItem={activeDetailsItem}
                                        onCloseDetails={onCloseDetails}
                                        onOpenDetails={onOpenDetails}
                                    />
                                )
                            }
                        })}
                    </div>
                )}
            </div>
        </div>
    )
}

export default compose(
    connect(mapStateToProps, null),
    toJS()
)(FilterResultsList)